import { Box } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';

function OverlayIcon({ type, ...rest }) {
  switch (type) {
    case 'ADD':
      return <AddCircleIcon {...rest} />;
    case 'EXPORT':
      return <DownloadForOfflineIcon {...rest} />;
    default:
      return null;
  }
}

function StackedIcon({
  Base,
  Overlay = null,
  overlayType = null,
  overlaySize = 16,
  overlayBg = 'background.paper',
  overlayColor = 'primary.main',
  ...rest
}) {
  const boxSize = overlaySize / 2;
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        mr: 0.3,
      }}
      {...rest}>
      {/* Base icon */}
      <Base {...rest} />

      {/* Overlay with background mask */}
      <Box
        sx={{
          position: 'absolute',
          bottom: '4px',
          right: '0px',
          width: boxSize,
          height: boxSize,
          borderRadius: '50%', // 👈 change to 1 for square
          backgroundColor: overlayBg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'none',
        }}>
        {Overlay ? (
          <Overlay sx={{ fontSize: overlaySize, color: overlayColor }} />
        ) : (
          <OverlayIcon
            type={overlayType}
            sx={{ fontSize: overlaySize, color: overlayColor }}
          />
        )}
      </Box>
    </Box>
  );
}

export default StackedIcon;
